import {useMsal} from "@azure/msal-react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useEffect} from "react";
import {apiRequest, loginRequest} from "../../authConfig";
import {getCustomersAsync} from "./customersSlice";
import {setActiveLink} from "../navmenu/navbarSlice";
import {connect} from "react-redux";
import {CustomerRow} from "./CustomerRow";
import {Button, Table} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import styles from './Customers.module.css';

export const Customers = () => {
    const navigate = useNavigate();
    const {instance, accounts} = useMsal();
    const dispatch = useAppDispatch();
    const customers = useAppSelector((state) => state.customers.customers);

    useEffect(() => {
        dispatch(setActiveLink('/customers'));
        requestApiAccessToken().then(apiToken =>
            dispatch(getCustomersAsync({apiToken: apiToken})));
    }, [dispatch, instance]);

    const requestApiAccessToken = async (): Promise<string> => {
        const request = {
            ...apiRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        }
    };

    const AddCustomer = () => {
        navigate('/customers/add');
    }

    return (
        <>
            <Table striped bordered hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Active</th>
                    <th>Created</th>
                    <th>Modified</th>
                </tr>
                </thead>
                <tbody>
                {customers.map((customer, index) =>
                    <CustomerRow key={++index} customer={customer} index={++index}/>
                )}
                </tbody>
            </Table>
            <div className={styles.right}>
                <Button
                    onClick={() => AddCustomer()}
                >
                    Create
                </Button>
            </div>
        </>
    );
};

export default connect()(Customers);
    
